var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultados(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83.786,
    height: 58.071,
    viewBox: "0 0 83.786 58.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_149125",
    "data-name": "Rect\\xE1ngulo 149125",
    width: 83.786,
    height: 58.071,
    transform: "translate(-18 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164270",
    "data-name": "Grupo 164270",
    transform: "translate(18 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_164269",
    "data-name": "Enmascarar grupo 164269",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_149124",
    "data-name": "Rect\\xE1ngulo 149124",
    width: 74.285,
    height: 56.571,
    rx: 4.339,
    transform: "translate(-9.25 0.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_89126",
    "data-name": "Trazado 89126",
    d: "M70.93,28.7l-.484-.016H47.173a.452.452,0,0,0-.44.279L44.346,36.09l-1.7-13.243a.475.475,0,0,0-.907-.012l-4.278,25.5L33.315,6.044a.427.427,0,0,0-.433-.349.44.44,0,0,0-.472.313L25.675,37.182l-2.8-12.841a.429.429,0,0,0-.391-.309.482.482,0,0,0-.472.216l-2.5,4.437H9.088a.388.388,0,1,0,0,.763H19.8a.473.473,0,0,0,.414-.219l2.017-3.58,3,13.74a.478.478,0,0,0,.9,0L32.689,9.013l4.193,42.815a.473.473,0,0,0,.907.022l4.338-25.857,1.564,12.151a.427.427,0,0,0,.416.339.465.465,0,0,0,.478-.277l2.933-8.758H70.736c.177,0,.414-.121.414-.219S71.107,28.706,70.93,28.7Z",
    transform: "translate(-10.363)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultados);
export default __webpack_public_path__ + "static/media/resultados.28808dd9ed2af24ff8bf168e4c3ff41b.svg";
export { ForwardRef as ReactComponent };